import Image from '@/components/Image';
import styles from './common.module.scss';
import { useInViewportAnimation } from '@/hooks/useInViewportAnimation'; // 导入动画hook

interface Part1Props {
  data?: {
    section_one: {
      top_img: string;
      title: string;
      content: string;
      size_list: Array<{
        name: string;
        sub_name: string;
        content: string;
      }>;
    };
    section_two: {
      top_img: string;
      title: string;
      content: string;
      content2: string;
      size_list: Array<{
        num1: string;
        num2: string;
        num3: string;
        name: string;
        value: string;
      }>;
    };
  };
  isMobile?: boolean;
}
export default function Part1({ data, isMobile = false }: Part1Props) {
  const iconImages = [
    '/static-page/fit-guide/img_icon1.png',
    '/static-page/fit-guide/img_icon2.png',
    '/static-page/fit-guide/img_icon3.png',
  ];

  // 动画hook，仅PC端执行
  const animationRef = useInViewportAnimation(
    () => {
      if (isMobile) return;
      try {
        const part1_arr = [
          'fit-guide-container-section-part1-section-one-inner',
          'fit-guide-container-section-part1-section-two-inner',
        ];
        const part1_img_arr = [
          'fit-guide-container-section-part1-section-one-img',
          'fit-guide-container-section-part1-section-two-img',
        ];
        part1_arr.forEach((item) => {
          const dom = document.getElementsByClassName(item);
          Array.from(dom).forEach((el) => {
            el.classList.add('opacity0');
          });
        });
        part1_img_arr.forEach((item) => {
          const dom = document.getElementsByClassName(item);
          Array.from(dom).forEach((el) => {
            el.classList.add('opacity0');
          });
        });
        Array.from(part1_arr).forEach((item, idx) => {
          setTimeout(() => {
            const elements = document.getElementsByClassName(item);
            Array.from(elements).forEach((el) => {
              el.classList.add('fadeInDownAnimate');
            });
          }, idx * 120);
        });
        Array.from(part1_img_arr).forEach((item, idx) => {
          setTimeout(() => {
            const elements = document.getElementsByClassName(item);
            Array.from(elements).forEach((el) => {
              el.classList.add('activityFadeInUpAnimate');
            });
          }, idx * 120);
        });
      } catch {
        const elements = document.querySelectorAll('.opacity0');
        elements.forEach((el) => {
          const element = el as HTMLElement;
          element.style.opacity = '1';
        });
      }
    },
    { threshold: 0.3, once: true },
  );

  if (!data) return null;

  return (
    <div
      className={`${isMobile ? 'pt-[20px] px-[14px] pb-0' : 'pt-[2.5vw] px-[10.42vw] pb-[2.97vw]'}`}
      ref={(node) => {
        if (!isMobile && animationRef && typeof animationRef !== 'function') {
          (animationRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
        }
      }}
    >
      {/* Section One */}
      <div className={`${isMobile ? 'block' : 'flex justify-between items-start'}`}>
        <Image
          src={data.section_one.top_img}
          alt={data.section_one.title}
          width={1388}
          height={760}
          className={`${
            isMobile
              ? 'block w-full h-auto aspect-[1388/760]'
              : 'fit-guide-container-section-part1-section-one-img block w-[37.5vw] h-auto aspect-[720/380]'
          }`}
        />
        <div
          className={`${
            isMobile
              ? 'block'
              : 'fit-guide-container-section-part1-section-one-inner flex h-[-webkit-fill-available] flex-col justify-center w-[34.375vw]'
          }`}
        >
          <div className={`${isMobile ? 'block' : 'text-left'}`}>
            <h2
              className={`${
                isMobile
                  ? 'mt-[20px] mb-[10px] text-[16px] leading-[20px] text-left'
                  : 'text-[max(1.67vw,20px)] leading-[max(2.03vw,20px)]'
              } ${styles['max-line-1']}`}
              dangerouslySetInnerHTML={{ __html: data.section_one.title }}
              style={{ fontFamily: 'var(--font-bricolage-bold)' }}
            />
            <div
              className={`${
                isMobile
                  ? 'text-[13px] leading-[20px] font-[var(--font-instrument)]'
                  : 'text-[max(0.83vw,14px)] leading-[max(1.25vw,14px)] mt-[18px] mb-[32px]'
              } ${styles[`max-line-${isMobile ? '4' : '3'}`]}`}
              dangerouslySetInnerHTML={{ __html: data.section_one.content }}
            />
          </div>
          {data.section_one.size_list && data.section_one.size_list.length > 0 && (
            <div className={`${isMobile ? 'flex flex-col mt-[20px]' : 'block'}`}>
              {data.section_one.size_list.map((item, index) => (
                <div
                  key={index}
                  className={`${
                    isMobile
                      ? 'flex items-center bg-[#f4f4f4] mb-[8px] px-[12px] py-[10px] rounded-[6px] last:mb-0'
                      : 'flex items-center mb-[14px] last:mb-0'
                  }`}
                >
                  <div
                    className={`${
                      isMobile
                        ? 'flex flex-col justify-center items-center min-w-[50px] mr-[15px]'
                        : 'flex items-center'
                    }`}
                  >
                    <span
                      className={`${
                        isMobile
                          ? 'text-[20px] leading-[24px]'
                          : 'w-[25px] text-[max(1.04vw,14px)] leading-[max(1.25vw,16px)] whitespace-nowrap'
                      }`}
                      style={{ fontFamily: 'var(--font-bricolage-bold)' }}
                    >
                      {item.name}
                    </span>
                    <span
                      className={`${
                        isMobile
                          ? 'text-[12px] leading-[14px]  whitespace-nowrap'
                          : 'w-[85px] min-w-[70px] mx-[10px] mr-[32px] text-[max(0.83vw,14px)] leading-[max(0.99vw,14px)]  whitespace-nowrap'
                      }`}
                    >
                      {item.sub_name}
                    </span>
                  </div>
                  <div
                    className={`${
                      isMobile
                        ? 'text-[13px] leading-[20px] font-[var(--font-instrument)]'
                        : 'text-[max(0.83vw,14px)] leading-[max(0.99vw,14px)] font-[var(--font-bricolage)] flex-1'
                    }`}
                  >
                    {item.content}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Section Two */}
      <div
        className={`${isMobile ? 'block mt-[32px]' : 'flex justify-between items-start mt-[55px]'}`}
      >
        {isMobile && (
          <Image
            src={data.section_two.top_img}
            alt={data.section_two.title}
            className="fit-guide-container-section-part1-section-two-img block w-full h-auto aspect-[1388/760]"
            width={720}
            height={380}
          />
        )}
        <div
          className={`${
            isMobile
              ? 'block'
              : 'fit-guide-container-section-part1-section-two-inner flex flex-col justify-center w-[34.375vw]'
          }`}
        >
          <div className={`${isMobile ? 'block' : 'text-left'}`}>
            <h2
              className={`${
                isMobile
                  ? 'mt-[20px] mb-[10px] text-[16px] leading-[20px] text-left'
                  : 'text-[max(1.67vw,20px)] leading-[max(2.03vw,20px)]'
              }  ${styles['max-line-1']}`}
              dangerouslySetInnerHTML={{ __html: data.section_two.title }}
              style={{ fontFamily: 'var(--font-bricolage-bold)' }}
            />
            <div
              className={`${
                isMobile
                  ? 'text-[13px] leading-[20px]'
                  : 'text-[max(0.83vw,14px)] leading-[max(1.25vw,14px)] mt-[18px] mb-[32px] '
              } ${styles[`max-line-${isMobile ? '4' : '3'}`]}`}
              dangerouslySetInnerHTML={{ __html: data.section_two.content }}
            />
          </div>
          {data.section_two.size_list && data.section_two.size_list.length > 0 && (
            <div
              className={`${
                isMobile ? 'flex flex-col mt-[16px] p-[16px] bg-[#f4f4f4] rounded-[6px]' : 'block'
              }`}
            >
              {data.section_two.size_list.map((item, index) => (
                <div
                  key={index}
                  className={`${
                    isMobile
                      ? 'flex items-center mb-[16px] last:mb-0'
                      : 'flex items-center mb-[20px] last:mb-0'
                  }`}
                >
                  <Image
                    src={iconImages[index]}
                    alt=""
                    width={64}
                    height={64}
                    className={`${isMobile ? 'w-[40px] h-auto' : 'w-[3.33vw] h-auto block'}`}
                  />
                  <div
                    className={`${
                      isMobile
                        ? 'flex justify-center items-center w-[64px] h-[20px] mx-[8px] ml-[12px] bg-white rounded-[4px]'
                        : 'flex items-center w-[5.52vw] h-[1.67vw] min-w-[95px] mx-[1.25vw] ml-[0.83vw] px-[12px] py-[6px] bg-[#f4f4f4] rounded-[6px] box-border'
                    }`}
                  >
                    <div
                      className={`${
                        isMobile
                          ? 'text-[12px] leading-[14px] font-[var(--font-instrument)] text-[#808080]'
                          : 'text-[max(0.83vw,14px)] leading-[max(0.99vw,14px)] text-[#808080] box-border'
                      } ${index === 0 ? 'text-[var(--color-primary-purple)]' : ''}`}
                    >
                      {item.num1}
                    </div>
                    <div
                      className={`${
                        isMobile
                          ? 'w-[7px] h-[7px] mx-[2px] ml-[3px] border border-[#808080]'
                          : 'w-[12px] h-[12px] mx-[4px] min-w-[10px] min-h-[10px] border border-[#808080]'
                      }`}
                    />
                    <div
                      className={`${
                        isMobile
                          ? 'text-[12px] leading-[14px] font-[var(--font-instrument)] text-[#808080]'
                          : 'text-[max(0.83vw,14px)] leading-[max(0.99vw,14px)] text-[#808080] box-border'
                      } ${index === 1 ? 'text-[var(--color-primary-purple)]' : ''}`}
                    >
                      {item.num2}-
                    </div>
                    <div
                      className={`${
                        isMobile
                          ? 'text-[12px] leading-[14px] font-[var(--font-instrument)] text-[#808080]'
                          : 'text-[max(0.83vw,14px)] leading-[max(0.99vw,14px)] text-[#808080] box-border'
                      } ${index === 2 ? 'text-[var(--color-primary-purple)]' : ''}`}
                    >
                      {item.num3}
                    </div>
                  </div>
                  <div
                    className={`${
                      isMobile
                        ? 'text-[13px]'
                        : 'text-[max(0.83vw,14px)] leading-[max(0.99vw,14px)] mr-[8px]'
                    }`}
                  >
                    {item.name}
                  </div>
                  <div
                    className={`${
                      isMobile
                        ? 'ml-[4px] text-[13px]'
                        : 'text-[max(0.83vw,14px)] leading-[max(0.99vw,14px)]'
                    }`}
                    style={{ fontFamily: 'var(--font-bricolage-bold' }}
                  >
                    {item.value}
                  </div>
                </div>
              ))}
            </div>
          )}
          <div
            className={`${
              isMobile
                ? 'mt-[12px] text-[13px] leading-[20px] font-[var(--font-instrument)]'
                : 'mt-[32px] text-[max(0.83vw,14px)] leading-[max(1.25vw,14px)] font-[bricolageGrotesque]'
            } ${styles[`max-line-${isMobile ? '4' : '3'}`]}`}
            dangerouslySetInnerHTML={{ __html: data.section_two.content2 }}
          />
        </div>
        {!isMobile && (
          <Image
            src={data.section_two.top_img}
            alt={data.section_two.title}
            width={720}
            height={380}
            className="fit-guide-container-section-part1-section-two-img block w-[37.5vw] h-auto aspect-[720/380]"
          />
        )}
      </div>
    </div>
  );
}
